import { z } from "zod";
export const EstadoDispositivoEnum = z.enum(["PENDIENTE", "APROBADO", "RECHAZADO"]);
export const DispositivoMeseraRespuestaSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    usuarioId: z.string(),
    ip: z.string(),
    userAgent: z.string().nullable(),
    estado: EstadoDispositivoEnum,
    solicitadoEn: z.string(),
    resueltoEn: z.string().nullable(),
    usuario: z.object({ id: z.string(), nombre: z.string(), usuario: z.string() }),
});
//# sourceMappingURL=dispositivos-mesera.schema.js.map